/* 
 When collection with whitelist opened by owner,
 tracking
*/

import { backend } from "@/services/backend";
const isCollectionTracking = new Map<string, boolean>();

export const whitelistTracker = async (collection: string) => {
  const isTracking = isCollectionTracking.get(collection);
  if (isTracking) return;
  isCollectionTracking.set(collection, true);
  const listCount = await backend.getCollectionWhitelistCount(collection);
  const timeout = listCount * 200 + 30000;
  await backend.refreshCollectionWhitelist({
    collection,
    profiles: [],
  });
  setTimeout(() => whitelistTracker(collection), timeout);
};
